import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './TopbarSpacer.module.css';

/**
 * Reserves the vertical space occupied by the topbar.
 *
 * The real, interactive Topbar is rendered once, globally, as a
 * `position: fixed` element in Routes.js. Because that element is out of the
 * normal document flow, each page still needs to reserve the topbar's height
 * so page content starts below it.
 *
 * Previously every page mounted its own redux-connected <TopbarContainer /> for
 * this purpose. That second topbar was always hidden behind the persistent one
 * (unless scrolled above the top of the page), but it still rendered a full
 * Topbar, mobile menu, search form, ModalMissingInformation and
 * LimitedAccessBanner on every route — pure overhead. This lightweight spacer
 * replaces those instances: it reserves the same height without mounting a
 * second topbar.
 */
const TopbarSpacer = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return <div className={classes} aria-hidden="true" />;
};

TopbarSpacer.defaultProps = {
  className: null,
  rootClassName: null,
};

TopbarSpacer.propTypes = {
  className: string,
  rootClassName: string,
};

export default TopbarSpacer;
